export default __webpack_public_path__ + "static/media/vpc_networks.eaecf9f4.svg";